import { Building2, Phone, Scale, Users } from 'lucide-react';
import React from 'react';

import { NOTE_TYPES, NoteType } from '@/services/types/matter-notes-types';

import {
  CLIENT_EMPLOYMENT_MATTER_NOTE_CONFIG,
  EMERGENCY_CONTACT_MATTER_NOTE_CONFIG,
  INVOLVED_PERSON_MATTER_NOTE_CONFIG,
  PRIOR_LAWSUIT_MATTER_NOTE_CONFIG,
} from '../matter-notes-v2/constants';
import { MatterNoteConfig } from '../matter-notes-v2/types';
import { PeopleSectionCard } from './people-tab/PeopleSectionCard';

interface PeopleTabProps {
  matterId: string;
}

// Section configuration for People tab
interface PeopleSectionConfig {
  noteType: NoteType;
  config: MatterNoteConfig;
  icon: React.ReactNode;
  emptyTitle: string;
  emptyDescription: string;
  addButtonLabel: string;
}

const PEOPLE_SECTIONS: PeopleSectionConfig[] = [
  {
    noteType: NOTE_TYPES.CLIENT_EMPLOYMENT,
    config: CLIENT_EMPLOYMENT_MATTER_NOTE_CONFIG,
    icon: <Building2 className="h-5 w-5" />,
    emptyTitle: 'No employment information',
    emptyDescription:
      "Add the client's employment details including employer, role, and wage information.",
    addButtonLabel: 'Add Employment',
  },
  {
    noteType: NOTE_TYPES.EMERGENCY_CONTACT,
    config: EMERGENCY_CONTACT_MATTER_NOTE_CONFIG,
    icon: <Phone className="h-5 w-5" />,
    emptyTitle: 'No emergency contact',
    emptyDescription:
      'Add an emergency contact for the client. This information is important for urgent communications.',
    addButtonLabel: 'Add Emergency Contact',
  },
  {
    noteType: NOTE_TYPES.PRIOR_LAWSUIT,
    config: PRIOR_LAWSUIT_MATTER_NOTE_CONFIG,
    icon: <Scale className="h-5 w-5" />,
    emptyTitle: 'No prior lawsuits',
    emptyDescription:
      'Track any prior lawsuits the client has been involved in. This helps assess case history.',
    addButtonLabel: 'Add Prior Lawsuit',
  },
  {
    noteType: NOTE_TYPES.INVOLVED_PERSON,
    config: INVOLVED_PERSON_MATTER_NOTE_CONFIG,
    icon: <Users className="h-5 w-5" />,
    emptyTitle: 'No additional parties',
    emptyDescription:
      'Add other people involved in the case such as witnesses, other drivers, or family members.',
    addButtonLabel: 'Add Person',
  },
];

export const PeopleTab: React.FC<PeopleTabProps> = ({ matterId }) => {
  return (
    <div className="space-y-4">
      {PEOPLE_SECTIONS.map((section) => (
        <PeopleSectionCard
          key={section.noteType}
          matterId={matterId}
          section={section}
        />
      ))}
    </div>
  );
};

export default PeopleTab;
